// extracted by mini-css-extract-plugin
export var fallbackIcon = "wpfLu";